import React from 'react';

const DAY_ORDER = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

const DAY_NAMES = {
  mon: 'Montag',
  tue: 'Dienstag',
  wed: 'Mittwoch',
  thu: 'Donnerstag',
  fri: 'Freitag',
  sat: 'Samstag',
  sun: 'Sonntag',
};

const DAY_SHORT = {
  mon: 'Mo',
  tue: 'Di',
  wed: 'Mi',
  thu: 'Do',
  fri: 'Fr',
  sat: 'Sa',
  sun: 'So',
};

function formatClock(value) {
  if (value === undefined || value === null || value === '') return '';
  const hours = Math.floor(value);
  const minutes = Math.round((value - hours) * 60);
  return `${hours}:${String(minutes).padStart(2, '0')}`;
}

function slotsOf(opening) {
  if (!opening || !opening.length) return [];
  return opening
    .map((slot) => {
      const from = Array.isArray(slot) ? slot[0] : slot;
      const to = Array.isArray(slot) ? slot[1] : '';
      if (from === undefined || from === null || from === '') return null;
      return `${formatClock(from)} – ${formatClock(to)}`;
    })
    .filter(Boolean);
}

function groupDays(openingHours) {
  const groups = [];
  DAY_ORDER.forEach((day) => {
    if (openingHours[day] === undefined) return;
    const key = JSON.stringify(openingHours[day] || []);
    const last = groups[groups.length - 1];
    const lastDay = last && last.days[last.days.length - 1];
    const consecutive = lastDay && DAY_ORDER.indexOf(day) === DAY_ORDER.indexOf(lastDay) + 1;
    if (last && last.key === key && consecutive) {
      last.days.push(day);
    } else {
      groups.push({ days: [day], opening: openingHours[day], key });
    }
  });
  return groups;
}

function labelDays(days) {
  if (days.length === 1) return DAY_NAMES[days[0]];
  return `${DAY_SHORT[days[0]]} – ${DAY_SHORT[days[days.length - 1]]}`;
}

export default function StartSection(props) {
  const openingHours = props.openingHours || {};
  const groups = groupDays(openingHours);
  const today = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'][new Date().getDay()];
  const todaySlots = slotsOf(openingHours[today]);
  const todayKnown = openingHours[today] !== undefined;
  const welcomeTitle = props.homeWelcomeTitle || 'Willkommen in Davos';
  const welcomeHtml = props.homeWelcomeText || `
    <p>Die Sportplatzgarage Gutknecht ist Ihr <strong>stop+go Partner in Davos</strong> –
    Spezialist für Service, Diagnose und Reparatur an <strong>Volkswagen, Audi, SEAT, Škoda und CUPRA</strong>.</p>
    <p>Persönlich, kompetent und fair – an der Mattastrasse 46.</p>
  `;

  return (
    <section className="spg-section">
      <div className="spg-intro-grid">
        <div>
          <div className="spg-kicker">Ankommen</div>
          <h2 className="spg-title">{welcomeTitle}</h2>
          <div
            className="spg-lead"
            dangerouslySetInnerHTML={{ __html: welcomeHtml }}
          />
        </div>

        {groups.length > 0 && (
          <aside className="spg-hours-card">
            <div className="spg-hours-head">
              <div>
                <div className="spg-kicker">Vor Ort</div>
                <h2 className="spg-hours-title">Öffnungszeiten</h2>
              </div>
              {todayKnown && (
                <span className={`spg-hours-badge ${todaySlots.length ? 'is-open' : 'is-closed'}`}>
                  {todaySlots.length ? 'Heute geöffnet' : 'Heute geschlossen'}
                </span>
              )}
            </div>

            <div className="spg-hours">
              {groups.map((group) => {
                const slots = slotsOf(group.opening);
                const isToday = group.days.includes(today);
                return (
                  <div
                    className={`spg-hour-row${isToday ? ' is-today' : ''}`}
                    key={group.key + group.days.join('-')}
                  >
                    <span className="spg-hour-day">
                      {labelDays(group.days)}
                      {isToday && <em>Heute</em>}
                    </span>
                    {slots.length ? (
                      <span className="spg-hour-slots">
                        {slots.map((slot) => (
                          <span className="spg-hour-time" key={slot}>{slot}</span>
                        ))}
                      </span>
                    ) : (
                      <span className="spg-hour-time is-closed">geschlossen</span>
                    )}
                  </div>
                );
              })}
            </div>
          </aside>
        )}
      </div>
    </section>
  );
}
